<template>
  <div class="base-date-range-picker">
    <v-date-picker
      :modelValue="modelValue"
      :firstDayOfWeek="2"
      :columns="2"
      :isDark="isDark"
      :masks="calendarMasks"
      :attributes="calendarAttributes"
      color="accent"
      locale="en"
      mode="date"
      isExpanded
      isRange
      trimWeeks
      class="base-date-range-picker__calendar"
      @update:modelValue="emit('update:modelValue', $event)"
    />
    <div class="base-date-range-picker__actions">
      <button
        type="button"
        class="base-date-range-picker__cancel"
        @click="emit('cancel')"
      >
        Cancel
      </button>
      <button
        type="button"
        class="base-date-range-picker__apply"
        :disabled="!modelValue"
        @click="apply"
      >
        Ok
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Globally available two-month range picker that keeps the shared calendar design consistent.
 * The consumer owns the draft range and decides whether Apply or Cancel closes its popover.
 */
import { computed } from "vue"
import { useStore } from "vuex"

import { Getters } from "@/store"
import { getTodayCalendarDate } from "@/utils/dateUtil"

interface CalendarRange {
  start: Date
  end: Date
}

const props = defineProps<{
  modelValue: CalendarRange | null
}>()

const emit = defineEmits<{
  "update:modelValue": [value: CalendarRange | null]
  apply: [value: CalendarRange]
  cancel: []
}>()

const store = useStore()
const isDark = computed(() => store.getters[Getters.THEME_IS_DARK] as boolean)
const calendarMasks = {
  title: "MMMM",
  weekdays: "WW"
}
const calendarAttributes = computed(() => [
  {
    key: "today",
    order: -1,
    highlight: {
      class: "base-date-range-picker__today"
    },
    content: {
      style: {
        color: "var(--monochrome-06)"
      }
    },
    dates: getTodayCalendarDate()
  }
])

function apply() {
  if (props.modelValue) emit("apply", props.modelValue)
}
</script>
